<template>
    <new-modal
        size="sm"
        title="Create a Classroom"
        :close-on-bg-click="false"
        ref="createClassroomModal"
        v-on:modal-closed="resetForm"
    >
        <template #trigger>
            <div class="btn btn-primary">+ New Classroom</div>
        </template>
        <template #content>
            <form @submit.prevent="submit">
                <div class="flex flex-col gap-4">
                    <div class="">
                        <form-input
                            v-model="form.classroomName"
                            name="classroomName"
                            label="Classroom Name"
                        />
                    </div>
                    <div class="">
                        <form-select
                            v-model="form.ownerId"
                            name="ownerId"
                            label="Owner"
                            :options="groupAdminOptions"
                        />
                    </div>
                    <hr />
                    <div class="flex flex-col">
                        <div class="mb-2 text-[15px]">
                            <span class="font-semibold">Classroom Goals </span>
                            <span class="text-gray-650">(Optional)</span>
                        </div>

                        <div class="mb-4 text-[15px] leading-6 text-gray-650">
                            Your students will see these goals on their
                            dashboard. Don't worry, you can change them later
                        </div>

                        <div
                            class="mb-4 flex items-center text-[15px]"
                            v-for="(goal, index) in form.goals"
                        >
                            <div
                                class="text-medium mr-4 flex h-10 w-10 items-center justify-center rounded rounded-full bg-blue-300 text-[15px] text-white"
                            >
                                {{ goal.label }}
                            </div>
                            <div
                                class="flex items-center gap-2 whitespace-nowrap"
                            >
                                <div>{{ goal.prefix }}</div>
                                <div class="mr-2 w-24">
                                    <form-input-number
                                        v-model="form.goals[index].target"
                                        wrapper-css-classes="inline !max-w-24"
                                        :placeholder="goal.placeholder"
                                        type="number"
                                        css-classes="!pr-2"
                                        :min="0"
                                        :max="9999"
                                    />
                                </div>
                                <div class="">{{ goal.suffix }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="flex items-center justify-end">
                        <div class="btn btn-transparent" @click="cancel()">
                            Cancel
                        </div>
                        <button
                            :class="
                                'btn' +
                                ' ' +
                                (form.isDirty ? 'btn-primary' : 'btn-disabled')
                            "
                        >
                            Create classroom
                        </button>
                    </div>
                </div>
            </form>
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal";
import FormInput from "@/Components/FormInput";
import FormInputNumber from "@/Components/FormInputNumber";
import FormSelect from "@/Components/FormSelect";

export default {
    name: "GroupCreateClassroomModal",
    components: { FormSelect, FormInput, FormInputNumber, NewModal },
    data() {
        return {
            groupAdminOptions: this.$page.props.groupAdminOptions,
            form: this.$inertia.form({
                classroomName: "",
                ownerId: null,
                goals: this.$page.props.defaultClassroomGoals,
            }),
        };
    },
    methods: {
        submit() {
            let vm = this;

            vm.$inertia.post(route("group.classroom.create"), vm.form, {
                onSuccess() {
                    vm.form.reset();
                    vm.$refs.createClassroomModal.closeModal();
                },
            });
        },
        resetForm() {
            this.form.reset();
        },
        cancel() {
            this.form.reset();
            this.$refs.createClassroomModal.closeModal();
        },
    },
};
</script>
